import React from "react";
import { ServiceAgreementUploadModal } from "./components/Modal";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";
import { ServiceAgreementUploadModalProps } from "./types";

// export function openServiceAgreementUpload() {
//     return createConfirmation<ServiceAgreementUploadModalProps, void>(confirmable((props) => (

//     )))({
//             dialogId: 'email_popout_modal'
//         });
// }

export function openServiceAgreementUpload(feeAgreementId: string) {
    return createConfirmation<ServiceAgreementUploadModalProps, any>(confirmable((props) => (
        <ServiceAgreementUploadModal {...props} />
    )))({
        dialogId: 'service_agreement_upload',
        feeAgreementId
    });
}